import * as React from 'react';
import { supportedWidgets } from '@api/schema/supportedWidgets';

export default function DashboardWidget({
  widget,
  updateWidget,
  isEditing,
  onRemove,
}) {

  // todo: add a widget type for report view, which runs a saved report and displays its contents
  // todo: make calendar smart

  if(!widget?.type || !widget?.options?.type) {
    return null;
  }

  if(
    !supportedWidgets?.[widget.type]?.[widget.options.type]
  ) {
    return <em>This widget is unsupported {widget?.type} {widget?.options?.type}.</em>
  }

  const WidgetView = supportedWidgets[widget.type][widget.options.type].widget;

  const onEdit = () => {
    console.log('edit button presed');
  }

  return (
    <WidgetView
      {...widget} // this is legacy and should be removed once widgets are converted to use widget prop
      widget={widget}
      updateWidget={updateWidget}
      isEditing={isEditing}
      onEdit={onEdit}
      onRemove={()=>onRemove(widget)}
    />
  )
}
